import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { PopupComponent } from '@app/components/popup/popup.component';
import { ContentImageCard } from '@app/components/widget/content-image-card/content-image-card.component';
import { BaseService } from '@app/system/services/base.service';
import { DetectDeviceService } from '@app/system/services/detect-device.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { LocaleService } from '@app/system/services/locale.service';
import { CourseFormsComponent } from '../course-forms/course-forms.component';
import { ApiService } from '../utilities/services/api.service';
import { TakeCourseComponent } from '../take-course/take-course.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { AssessmentFormsComponent } from '@app/modules/assessment/assessment-forms/assessment-forms.component';
import { ApiService as AssessmentApiService } from '@app/modules/assessment/utilities/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService as ResourceApiService } from '../../resource/utilities/services/api.service';
import { EventCard } from '@app/components/widget/event-card/event-card.component';
import { PlaylistCard } from '@app/components/widget/playlist-card/playlist-card.component';
import { QuestionCard } from '@app/components/widget/question-card/question-card.component';

@Component({
	selector: 'app-course-detail',
	templateUrl: './course-detail.component.html',
	styleUrls: ['./course-detail.component.scss']
})
export class CourseDetailComponent implements OnInit {

	@Input() resourceDetail;
	@Input() popupRef;
	@Input() additionalData;
	@Output() reloadResource = new EventEmitter();

	contentOpened = false;
	canAddModule = true;
	loader = false;
	currentUser;
	canUpdate = false;
	assessmentID;
	updateModulePos = false;
	updateActivityPos = false;
	submitDisable = false;
	deviceDetails;
	viewActivityData =  false;
	constructor(
		public detectDevice: DetectDeviceService,
		public locale: LocaleService,
		private popup: MatDialog,
		private baseService: BaseService,
		public gfService: GlobalFunctionService,
		private apiService: ApiService,
		private cdref: ChangeDetectorRef,
		private assessmentApiService: AssessmentApiService,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private resourceApiService: ResourceApiService
	) {
		this.currentUser = this.gfService.sessionUser;
	}

	ngOnInit(): void {
		this.deviceDetails = this.detectDevice.fingerPrint;
		this.dataBuild();
		if (this.baseService.checkAccessControl(['CON001', 'CON003'])) {
			this.viewActivityData = true;
		}
		
	}

	collapsibleToggle(event: any, targetElement = null) {
		// console.log(targetElement)
		this.contentOpened = event;
		this.cdref.detectChanges();
		// if (event) {
		// 	setTimeout(() => {
		// 		targetElement.el.nativeElement.scrollIntoView({
		// 			behavior: 'smooth'
		// 		});
		// 	}, 200);

		// }
	}

	dataBuild() {
		// if (this.resourceDetail.authors && this.resourceDetail.authors.length) {
		// 	if (this.resourceDetail.authors.find(items => items.userID === this.currentUser.userID)) {
		// 		this.canUpdate = true;
		// 	}
		// }
		if (this.resourceDetail.actionFrom && ['courseAll_published', 'course_requests'].includes(this.resourceDetail.actionFrom)) {
			this.contentOpened = true;
		}
		if (this.resourceDetail.resourceAction && this.resourceDetail.resourceAction.addModule) {
			this.canUpdate = true;
		}
		if (this.resourceDetail.infoFields && this.resourceDetail.infoFields.hasOwnProperty('course')) {
			this.resourceDetail.infoFields.course.courseDurationInHrs = this.gfService.formatTime(Number((this.resourceDetail.infoFields.course.courseDurationInHrs * 60)), 'hh:mm');
		}
		if (this.resourceDetail.infoFields && this.resourceDetail.infoFields.hasOwnProperty('courseModules') && Array.isArray(this.resourceDetail.infoFields.courseModules)) {
			for (const data of this.resourceDetail.infoFields.courseModules) {
				data.dragging = false;
				data.opened = false;
				if (data.activites && data.activites.length) {
					for (const activity of data.activites) {
						activity.contentType = this.baseService.referenceType('courseContentType', activity.type);
						if (activity.resourceFormat) {
							activity.resourceFormat = this.baseService.referenceType('resourceFormat', activity.resourceFormat);
						}
						if (activity.resourceTypeID) {
							activity.resourceTypeID = this.baseService.referenceType('resourceType', activity.resourceTypeID);
						}
					}
				} else {
					data.activites = [];
				}
				if (data.references && data.references.length) {
					const references = [];
					for (const record of data.references) {

						let finalData: any = {};
						if (record && record.resourceTypeID) {
							record.resourceTypeID = this.baseService.referenceType('resourceType', record.resourceTypeID);
							record.type = record.resourceTypeID.caption;


							if (record.resourceTypeID.key === 'answer') {
								const cardData: QuestionCard = {
									title: record.title,
									// date: this.gfService.dateFormat(data.createdAt, 'd MMM'),
									thumbnail: '',
									removable: false
								};
								// if (data.authors && data.authors.length) {
								// 	cardData.thumbnail = data.authors[0].profilePicURL;
								// 	cardData.creator = `${data.authors[0].firstName}${data.authors[0].lastName
								// 		? ' ' + data.authors[0].lastName
								// 		: ''}`;
								// 	if (data.authors.length > 1) {
								// 		cardData.usersCount = (data.authors.length - 1);
								// 	}
								// }

								finalData = cardData;
							} else if (record.resourceTypeID.key === 'playlist') {
								const cardData: PlaylistCard = {
									title: record.title,
									// date: this.gfService.dateFormat(data.createdAt, 'd MMM'),
									// type: resource.resourceType.caption,
									thumbnail: '',
									removable: false
									// playlistItemCount: data.count
								};

								finalData = cardData;
							} else if (['internalEvent', 'externalEvent'].includes(record.resourceTypeID.key)) {
								const cardData: EventCard = {
									thumbnail: '',
									title: record.title,
									eventType: (record.resourceTypeID && record.resourceTypeID.key) ? record.resourceTypeID.key : null,
									removable: false
								};
								if (record.resourceTypeID) {
									// if (data.infoFields) {
									// 	if (data.resourceType.key === 'internalEvent') {
									// 		if (data.infoFields.time) {
									// 			cardData.time = this.gfService.dateFormat(data.infoFields.time, 'shortTime');
									// 		}
									// 		if (data.infoFields.date.length) {
									// 			cardData.date = `${this.gfService.dateFormat(data.infoFields.date[0], 'd')} ${this.gfService.dateFormat(data.infoFields.date[0], 'MMM')} - ${this.gfService.dateFormat(data.infoFields.date[1], 'd')} ${this.gfService.dateFormat(data.infoFields.date[1], 'MMM')}`;
									// 		}
									// 	} else {
									// 		if (data.infoFields.date) {
									// 			cardData.date = this.gfService.dateFormat(data.infoFields.date, 'd MMM');
									// 		}
									// 	}
									// }
								}

								finalData = cardData;
							} else {
								const cardData: ContentImageCard = {
									title: record.title,
									// date: this.gfService.dateFormat(resource.createdAt, 'MMM d, y'),
									thumbnail: '',
									removable: false
								};
								finalData = cardData;
							}

							if (this.canAddModule && this.canUpdate) {
								finalData.removable = true;
							}

							if (record.description) {
								finalData.description = record.description;
							}

							finalData.type = record.resourceTypeID.caption;
						}

						if (record.resource.hasOwnProperty('duration')) {
							finalData.duration = record.resource.duration;
						}

						if (record.resource && record.resource.thumbnail && record.resourceTypeID && record.resourceTypeID.key !== 'answer') {
							finalData.thumbnail = record.resource.thumbnail;
						}
						if (record.resourceFormat) {
							record.resourceFormat = this.baseService.referenceType('resourceFormat', record.resourceFormat);
							finalData.format = record.resourceFormat.key;
							if (finalData.thumbnail === '') {
								finalData.thumbnail = record.resourceFormat.image;
							}
						}

						const extraData = {
							resourceID: record.resourceID,
							createdBy: record.createdBy
						};
						references.push(this.gfService.JSONMerge(finalData, extraData));
					}
					data.references = references;
				} else {
					data.references = [];
				}
			}
		}
		if (this.resourceDetail.enrollmentDetail){
			if(this.resourceDetail.enrollmentDetail.enrolmentDate){
				this.resourceDetail.enrollmentDetail.enrolmentDate =  this.gfService.dateFormat(this.resourceDetail.enrollmentDetail.enrolmentDate, 'MMM d, y');
			}
			if(this.resourceDetail.enrollmentDetail.completionDate){
				this.resourceDetail.enrollmentDetail.completionDate =  this.gfService.dateFormat(this.resourceDetail.enrollmentDetail.completionDate, 'MMM d, y');
			}
		}
	}

	addAssessment(addAssessmentActionEl) {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: AssessmentFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: 'createTest'
					},
					{
						variableName: 'record',
						value: this.resourceDetail
					}
				],
				triggerEl: addAssessmentActionEl
			},
			disableClose: true,
			maxWidth: '860px'
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (result && typeof result === 'object') {
				this.assessmentID = result.recordID;
				this.addQuestionDistribution();
			}
		});
	}

	addQuestionDistribution() {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: AssessmentFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: 'questionDistribution'
					},
					{
						variableName: 'assessmentID',
						value: this.assessmentID
					},
					{
						variableName: 'coveredSkills',
						value: this.resourceDetail.skills
					}
				]
			},
			disableClose: true,
			maxWidth: '860px',
			autoFocus: false
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (result && typeof result === 'object' && result.testData) {
				// const pushJson: any = result.testData;
				// pushJson.totalPoints = result.totalPoints;
				// this.assessmentData.push(pushJson);
			}
		});
	}

	updateActivityAssessment(data, additionalInfo: any = {}) {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: AssessmentFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: 'updateAssessment'
					},
					{
						variableName: 'record',
						value: data
					},
					{
						variableName: 'assessmentID',
						value: data.id
					},
					{
						variableName: 'coveredSkills',
						value: this.resourceDetail.skills
					},
					{
						variableName: 'courseDetails',
						value: additionalInfo
					}
				],
				triggerEl: additionalInfo.actionEl
			},
			disableClose: true,
			maxWidth: '860px',
			autoFocus: false
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (result && typeof result === 'object') {
				if (result.testData) {
					data.title = result.testData.name;
				} else if (result.action && result.action === 'deleted') {
					this.resourceDetail.infoFields.courseModules[additionalInfo.moduleIndex].activites.splice(additionalInfo.index, 1);
				}
			}
		});
	}

	addModule() {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: CourseFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: 'addModule'
					},
					{
						variableName: 'record',
						value: this.resourceDetail
					}
				]
			},
			disableClose: true,
			maxWidth: '860px'
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (result && typeof result === 'object') {
				const pushJson = {
					activites: [],
					index: 0,
					moduleID: result.recordID,
					moduleName: result.moduleName,
					references: [],
					dragging: false,
					sequenceActivities: result.sequenceActivities,
					unlockAfterPrevious: result.unlockAfterPrevious
				};
				if (this.resourceDetail.infoFields && this.resourceDetail.infoFields.hasOwnProperty('courseModules') && Array.isArray(this.resourceDetail.infoFields.courseModules)) {
					pushJson.index = this.resourceDetail.infoFields.courseModules.length + 1;
					this.resourceDetail.infoFields.courseModules.push(pushJson);
				} else {
					if (typeof this.resourceDetail.infoFields === 'object') {
						this.resourceDetail.infoFields['courseModules'] = [pushJson];
					} else {
						this.resourceDetail.infoFields = {
							courseModules: [pushJson]
						};
					}
				}
			}
		});
	}

	updateModule(data, actionEl?) {
		const record = { ...data };
		record.resourceID = this.resourceDetail.resourceID;
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: CourseFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: 'editModule'
					},
					{
						variableName: 'record',
						value: record
					}
				],
				triggerEl: actionEl
			},
			disableClose: true,
			maxWidth: '860px'
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (result && typeof result === 'object') {
				data.moduleName = result.moduleName;
				data.sequenceActivities = result.sequenceActivities;
				data.unlockAfterPrevious = result.unlockAfterPrevious;
			}
		});
	}

	chooseContentType(data) {
		const record = { ...data };
		record.resourceID = this.resourceDetail.resourceID;
		record.moduleData = this.resourceDetail.infoFields.courseModules;
		record.skills = this.resourceDetail.skills;
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: CourseFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: 'chooseContentType'
					},
					{
						variableName: 'record',
						value: record
					},
					{
						variableName: 'resourceDetail',
						value: this.resourceDetail
					}
				]
			},
			disableClose: true,
			maxWidth: '860px'
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (result && typeof result === 'object') {
				this.resourceDetail.infoFields.courseModules = result.moduleData;
				this.cdref.detectChanges();
			}
		});
	}

	enroll(actionEl) {
		if (navigator.onLine) {
			const enrolType = (this.resourceDetail && this.resourceDetail.infoFields && this.resourceDetail.infoFields.course && this.resourceDetail.infoFields.course.enrolment) ? this.resourceDetail.infoFields.course.enrolment : '';
			if (enrolType === 'anyone') {
				this.popupRef.componentInstance.popupLoader = true;
				this.submitDisable = true;
				const apiData = {
					notificationType: 1
				};
				const headers: any = {};
				if (this.deviceDetails.browserName === 'Safari') {
					apiData.notificationType = 2;
				}
				this.apiService.enroll(apiData, this.resourceDetail.resourceID, headers).subscribe(
					(response) => {
						this.baseService.logUserActivity('register', 'learning', [''], { resourceData: this.resourceDetail });
						let msg = 'course_enrolled';
						if (response) {
							if (response.statusCode === 'ENROLMENT_CREATED') {
								msg = 'course_enrolled';
							} else if (response.statusCode === 'ENROLMENT_REQUEST_CREATED') {
								msg = 'enrolment_request_has_been_sent';
							}
						}
						this.gfService.openSnackBar('SUCCESS', {
							message: this.locale.translate(msg),
							icon: 'check_circle_outline',
							position: 'before'
						});
						this.reloadResource.emit(true);
					},
					(error) => {
						if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === 'DUPLICATE') {
							error.error = this.locale.translate('course_already_being_enrolled');
							this.reloadResource.emit(true);
						}
						this.gfService.errorHandler(error, {
							snackBar: {
								position: 'before'
							}
						});
					}
				)
					.add(() => {
						this.popupRef.componentInstance.popupLoader = false;
					});
			} else {
				const dialogRef = this.popup.open(PopupComponent, {
					panelClass: ['custom-panel'],
					data: {
						action: 'dynamic',
						popup: true,
						component: CourseFormsComponent,
						componentData: [
							{
								variableName: 'action',
								value: 'enrollCourse'
							},
							{
								variableName: 'record',
								value: this.resourceDetail
							}
						],
						triggerEl: actionEl
					},
					disableClose: true,
					maxWidth: '860px'
				});
				dialogRef.afterClosed().subscribe((result) => {
					if (result && typeof result === 'object') {
						this.reloadResource.emit(true);
						// this.resourceDetail.enrollmentDetail = {
						// 	userID: this.currentUser.userID,
						// 	score: null,
						// 	progressPercentage: null,
						// 	enrollmentDate: Date.now()
						// };
					}
				});
			}
		}
	}

	enrollments(actionEl) {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: CourseFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: 'enrollmentUsers'
					},
					{
						variableName: 'record',
						value: this.resourceDetail
					}
				],
				triggerEl: actionEl
			},
			autoFocus: false,
			disableClose: true,
			maxWidth: '860px'
		});
		dialogRef.afterClosed().subscribe(async (result) => {
			if (result && typeof result === 'object') {
			}
		});
	}

	drop(event: CdkDragDrop<string[]>, data, type: string, index: number = null) {
		if (navigator.onLine) {
			if (data.length > 1) {
				if (event.currentIndex !== event.previousIndex) {
					moveItemInArray(data, event.previousIndex, event.currentIndex);
					if (type === 'activity') {
						this.updateActivityPos = true;
					} else if (type === 'courseModule') {
						this.updateModulePos = true;
					}
					// if (type === 'activity' || type === 'courseModule') {
					// 	// this.updateActivityPosition(data);
					// 	this.updatePosition(data, type);
					// }
				}
			}
		}
	}

	cdkDragStarted(event, data) {
		data.dragging = true;
	}

	cdkDragEnded(event, data) {
		data.dragging = false;
	}

	updateModulePosition() {
		this.updateModulePos = false;
		this.updatePosition(this.resourceDetail.infoFields.courseModules, 'courseModule');
	}

	resetModulePosition() {
		this.resourceDetail.infoFields.courseModules.sort((a, b) => a.index - b.index);
		this.updateModulePos = false;
	}

	updateActivityPosition(data) {
		this.updateActivityPos = false;
		this.updatePosition(data, 'activity');
	}

	resetActivityPosition(data) {
		data.sort((a, b) => a.index - b.index);
		this.updateActivityPos = false;
	}

	updatePosition(data, type: string) {
		if (navigator.onLine && data.length) {
			data.forEach((item, index) => {
				item.index = index;
			});

			// if (type === 'activity') {
			// 	this.resourceDetail.infoFields.courseModules.activites = data;
			// } else if (type === 'courseModule') {
			// 	this.resourceDetail.infoFields.courseModules = data;
			// }
			const infoFields = { ...this.resourceDetail.infoFields };
			if (infoFields.course.courseDurationInHrs) {
				infoFields.course.courseDurationInHrs = this.gfService.getTimeToSeconds(infoFields.course.courseDurationInHrs, { duration: 'minutes' });
			}
			const modules = [];
			for (const module of this.resourceDetail.infoFields.courseModules) {
				const pushJson = {
					index: module.index,
					moduleID: module.moduleID,
					moduleName: module.moduleName,
					activites: [],
					references: [],
					unlockAfterPrevious: !!module.unlockAfterPrevious,
        			sequenceActivities: !!module.sequenceActivities
				};
				if (module.activites && module.activites.length) {
					const activites = module.activites.map(items => {
						return {
							index: items.index,
							type: items.type,
							id: items.id
						};
					});
					pushJson.activites = activites;
				}
				if (module.references && module.references.length) {
					const references = module.references.map(items => {
						return items.resourceID;
					});
					pushJson.references = references;
				}
				modules.push(pushJson);
			}
			infoFields.courseModules = modules;
			const apiData: any = {
				infoFields: infoFields
			};
			const headers: any = {};
			this.apiService.updateResource(apiData, this.resourceDetail.resourceID, headers).subscribe(
				(response) => {
				},
				(error) => {
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			)
				.add(() => {
				});
		}
	}

	alertPopup(action, data, additionalInfo: any = {}) {
		let title = '';
		let content = '';
		if (action === 'deleteModule') {
			title = this.locale.translate('delete_module');
			content = this.locale.translate('delete_module_text');
		} else if (action === 'deleteActivity') {
			title = this.locale.translate('delete_activity');
			content = this.locale.translate('delete_activity_text');
		} else if (action === 'deleteReference') {
			title = this.locale.translate('delete_reference');
			content = this.locale.translate('delete_reference_text');
		} else if (action === 'deleteAssessment') {
			title = this.locale.translate('delete');
			content = this.locale.translate('delete_assessment_text');
		} else if (action === 'enrollActivity') {
			title =  this.locale.translate('enroll');
			content = this.locale.translate('enroll_text')
		}
		if (data.type === 'AT') {
			action = 'deleteActivityAssessment';
		}
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			autoFocus: false,
			data: {
				action: 'alert',
				classes: 'warning',
				popup: true,
				icon: 'warning',
				title,
				content,
				buttons: [
					{
						type: 'main-action',
						caption: this.locale.translate('yes'),
						key: 'yes'
					},
					{
						type: 'main-action',
						caption: this.locale.translate('no'),
						key: 'no',
						autoFocus: true
					}
				],
				triggerEl: additionalInfo.actionElement
			},
			disableClose: true,
			maxWidth: '560px'
		});
		dialogRef.afterClosed().subscribe((resp) => {
			if (resp) {
				if (resp.key === 'yes') {
					if (action === 'deleteModule') {
						this.deleteModule(data, additionalInfo);
					} else if (action === 'deleteActivity') {
						this.deleteModuleActivity(data, additionalInfo);
					} else if (action === 'deleteReference') {
						this.deleteActivityReference(data, additionalInfo);
					} else if (action === 'deleteAssessment') {
						this.deleteAssessment(data, additionalInfo);
					} else if (action === 'deleteActivityAssessment') {
						this.deleteAssessment(data, additionalInfo);
					} else if (action === 'enrollActivity') {
						this.enroll(additionalInfo)
					}
				}
			}
		});
	}

	deleteAssessment(data, additionalInfo) {
		const headers: any = {};
		let apiData: any = {};
		data.deleting = true;
		let id;
		if (data && data.type === 'AT') {
			apiData = {
				courseID: this.resourceDetail.resourceID,
				moduleID: this.resourceDetail.infoFields.courseModules[additionalInfo.moduleIndex].moduleID
			};
			id = data.id;
		} else {
			apiData = {};
			id = data.testID;
		}
		this.assessmentApiService.deleteTest(apiData, id, headers).subscribe(
			(response) => {
				let msg;
				if (data && data.type === 'AT') {
					msg = 'activity_deleted';
					this.resourceDetail.infoFields.courseModules[additionalInfo.moduleIndex].activites.splice(additionalInfo.index, 1);
				} else {
					msg = 'test_deleted';
				}
				this.gfService.openSnackBar('SUCCESS', {
					message: this.locale.translate(msg),
					icon: 'check_circle_outline',
					position: 'before'
				});
			},
			(error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			}
		).add(() => {
			data.deleting = false;
		});
	}

	deleteModule(data, additionalInfo) {
		const headers: any = {};
		data.deleting = true;
		this.apiService.deleteModule(this.resourceDetail.resourceID, data.moduleID, headers).subscribe(
			(response) => {
				this.resourceDetail.infoFields.courseModules.splice(additionalInfo.index, 1);
				this.gfService.openSnackBar('SUCCESS', {
					message: this.locale.translate('module_deleted'),
					icon: 'check_circle_outline',
					position: 'before'
				});
			},
			(error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			}
		).add(() => {
			data.deleting = false;
		});
	}

	deleteModuleActivity(data, additionalInfo) {
		const headers: any = {};
		data.deleting = true;
		this.apiService.deleteModuleActivity(this.resourceDetail.resourceID, this.resourceDetail.infoFields.courseModules[additionalInfo.moduleIndex].moduleID, data.type, data.id, headers).subscribe(
			(response) => {
				this.resourceDetail.infoFields.courseModules[additionalInfo.moduleIndex].activites.splice(additionalInfo.index, 1);
				this.gfService.openSnackBar('SUCCESS', {
					message: this.locale.translate('activity_deleted'),
					icon: 'check_circle_outline',
					position: 'before'
				});
			},
			(error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			}
		).add(() => {
			data.deleting = false;
		});
	}

	deleteActivityReference(data, additionalInfo) {
		const headers: any = {};
		data.deleting = true;
		this.apiService.deleteActivityReference(this.resourceDetail.resourceID, additionalInfo.activityData.moduleID, data.resourceID, headers).subscribe(
			(response) => {
				additionalInfo.activityData.references.splice(additionalInfo.index, 1);
				this.gfService.openSnackBar('SUCCESS', {
					message: this.locale.translate('reference_deleted'),
					icon: 'check_circle_outline',
					position: 'before'
				});
			},
			(error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			}
		).add(() => {
			data.deleting = false;
		});
	}

	nominate(actionEl) {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: CourseFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: 'nominate'
					},
					{
						variableName: 'record',
						value: this.resourceDetail
					}
				],
				triggerEl: actionEl
			},
			disableClose: true,
			maxWidth: '860px'
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (result && typeof result === 'object') {
			}
		});
	}

	learn() {
		// this.popupRef.close();
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			autoFocus: false,
			data: {
				action: 'dynamic',
				popup: true,
				component: TakeCourseComponent,
				componentData: [
					{
						variableName: 'actualResourceID',
						value: this.resourceDetail.resourceID
					},
					{
						variableName: 'completedPercentage',
						value: this.resourceDetail.completedPercent
					},
					{
						variableName: 'courseRead',
						value: this.resourceDetail.read
					}
				]
			},
			disableClose: true,
			maxHeight: '100%',
			maxWidth: '100%',
			height: '100%'
		});
		dialogRef.afterClosed().subscribe(async (result) => {
			if (result) {
			}
			// const queryParams = {
			// 	popup: null,
			// 	resourceID: null
			// };
			// this.router.navigate([], {
			// 	relativeTo: this.activatedRoute,
			// 	queryParamsHandling: 'merge',
			// 	queryParams
			// });
			this.updateReadStatus();
		});
	}

	updateReadStatus() {
		if (!this.resourceDetail.read) {
			this.loader = true;
			const headers: any = {
				lanCode: sessionStorage.getItem('locale') || 'en'
			};
			this.resourceApiService.getResourceReadStatus(this.resourceDetail.resourceID, headers).subscribe(
				(response) => {
					if (response) {
						if (response.course && Object.keys(response.course).length) {
							let count = 0;
							Object.keys(response.course).map(key => {
								if (response.course[key] && response.course[key].length) {
									for (const data of response.course[key]) {
										if (data.read) {
											count += 1;
										}
									}
								}
							});
							if (count) {
								let length = 0;
								if (this.resourceDetail.infoFields && this.resourceDetail.infoFields.courseModules && this.resourceDetail.infoFields.courseModules.length) {
									for (const module of this.resourceDetail.infoFields.courseModules) {
										if (module.activites && module.activites.length) {
											length = length + module.activites.length;
										}
									}
								}
								const percentage = (count / length) * 100;
								if (percentage !== this.resourceDetail.completedPercent) {
									const apiData = {
										type: 1,
										completedPercent: percentage
									};
									const readLogHeaders: any = {};
									this.resourceApiService.addReadLog(apiData, this.resourceDetail.resourceID, readLogHeaders).subscribe(
										(response) => {
											this.resourceDetail.read = response.read;
											this.resourceDetail.completedPercent = percentage;
											this.additionalData.read = response.read;
											if (response.read) {
												this.baseService.logUserActivity('read', 'learning', [''], { resourceData: this.resourceDetail });
											}
										},
										(error) => { }
									)
										.add(() => {
										});
								} else {
									this.loader = false;
								}
							}
						}
					}
				},
				(error) => {
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			)
				.add(() => {
					this.loader = false;
				});
		}
	}

	generateCertificate(actionEl) {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: CourseFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: 'generateCertificate'
					},
					{
						variableName: 'record',
						value: this.resourceDetail
					}
				],
				triggerEl: actionEl
			},
			disableClose: true,
			maxWidth: '860px'
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (result) {
				this.reloadResource.emit(true);
			}
		});
	}

	viewCertificate(actionEl) {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: CourseFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: 'viewCertificate'
					},
					{
						variableName: 'record',
						value: this.resourceDetail
					}
				],
				triggerEl: actionEl
			},
			disableClose: true,
			maxWidth: '860px'
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (result && typeof result === 'object') {
			}
		});
	}

	viewActivity(resourceID: number) {
        const dialogRef = this.popup.open(PopupComponent, {
            panelClass: ['custom-panel', 'advanced-content'],
            autoFocus: false,
            data: {
                action: 'dynamic',
                popup: true,
                component: import('@app/modules/resource/resource-detail/resource-detail.component'),
                componentData: [
                    {
                        variableName: 'actualResourceID',
                        value: resourceID
                    },
                ]
            },
            disableClose: true,
            maxHeight: '100%',
            maxWidth: '100%',
            height: '100%'
        });
        dialogRef.afterClosed().subscribe(async (result) => {
            if (result && typeof result === 'object') {
            }
        });
    }


}
